@if(!ViewSessionsScreen){
<div class="cupping-session">
  <rms-mod class="session-sidebar">
    <fieldset class="rms-fieldset session-list">
      <legend>Cupping Sessions</legend>
      <rms-table [IncludeSearch]="false" [IncludePaginator]="false" [data]="CuppingSessions" [columns]="CuppingSessionColumns" [clickableRow]="true" (onRowClick)="SelectCuppingSession($event)"></rms-table>
    </fieldset>
    <fieldset class="rms-fieldset coffee-dropzone" appDragDrop (dataDropped)="onRemoveFromTable($event)">
      <legend>Coffees to Cup</legend>

      <div class="coffee-container">

        @for (coffee of CoffeesToCup; track coffee.CuppingSessionDetailID) {
        <div class="coffee-card"
             appDragDrop
             [dragData]="getCoffeeDragPayload(coffee)"
             (dragstart)="onCoffeeDragStart($event, coffee)"
             (dragend)="onCoffeeDragEnd()">

          <span>
            {{ coffee.InventoryID ?? coffee.SampleOfferingID }} - {{ coffee.InventoryTypeName }}
          </span>

        </div>
        }

      </div>
    </fieldset>
  </rms-mod>


  <rms-mod class="session-main">
    @if(completionNotifications.length){<div class="completion-notices" role="status"><h3>Session follow-up</h3>
      @for(notice of completionNotifications; track $index){<p><strong>#{{notice.reference}}</strong> {{notice.message}}
        @if(notice.recipients.length){<br /><span>Email simulated: {{notice.recipients.join(', ')}}. No email sent.</span>}
      </p>}
      <button mat-button (click)="completionNotifications = []">Dismiss</button>
    </div>}
    @if(!SelectedCuppingSession){
    <div class="no-session-selected">
      <h2>Choose a cupping session</h2><p>Select a session on the left or create one to arrange your coffees.</p>
      <button mat-button class="btn-bg-green" style="width:100%" (click)="UpdateCuppingSession()">
        <mat-icon>add</mat-icon>
        Create New Session
      </button>
      <button mat-button class="btn-bg-green" style="width:100%" (click)="ViewSessionsScreen = true">
        View live cupping
      </button>
    </div>
    }
    @else {
    <div class="session-toolbar">
      <h1 class="column-title center">{{SelectedCuppingSession.editTables ? 'Update Layout' : 'Cupping Session'}} - {{SelectedCuppingSession.CuppingSessionKey}}</h1>
      <button mat-button class="btn-bg-green" (click)="UpdateCuppingSession()">
        <mat-icon>add</mat-icon>
        Create New Session
      </button>
      <button mat-button class="btn-bg-green" [disabled]="SelectedCuppingSession.Completed" (click)="StartCuppingSession()">
        {{SelectedCuppingSession.editTables ? 'Start Cupping Session' : 'Edit Cupping Session'}}
      </button>
    </div>

    <div class="table-layout">

      @for (table of tables; track table.tableNumber) {

      @if (table.position === 'top') {
      <div class="table-row horizontal" style="gap:10px">
        <div class="horizontal cupping-table">
          @for (slot of table.slots; let i = $index; track slot.slotNumber) {
          <ng-container [ngTemplateOutlet]="slotTemplate"
                        [ngTemplateOutletContext]="{ slot: slot, i: i, editMode: SelectedCuppingSession.editTables }">
          </ng-container>
          }
        </div>
      </div>
      }

      }

      <div class="table-row vertical-wrapper">

        @for (table of tables; track table.tableNumber) {

        @if (table.position === 'left' || table.position === 'right') {
        <div class="vertical-table cupping-table">
          @for (slot of table.slots; let i = $index; track slot.slotNumber) {
          <ng-container [ngTemplateOutlet]="slotTemplate"
                        [ngTemplateOutletContext]="{ slot: slot, i: i, editMode: SelectedCuppingSession.editTables }">
          </ng-container>
          }
        </div>
        }

        }
        <ng-template #slotTemplate let-slot="slot" let-i="i" let-editMode="editMode">
          <div class="table-slot"
                (click)="!editMode && openSlotDetail(slot)"
                appDragDrop
                [dragDisabled]="!editMode"
                (dataDropped)="editMode && onDropToSlot($event, slot)">

            <span class="slot-number">{{ i + 1 }}</span>

            @if (slot.coffee) {
            <div class="coffee-card placed" [class.approved]="slot.coffee.WasApproved"
                 [class.rejected]="!slot.coffee.WasApproved && slot.coffee.Completed && !slot.coffee.Recup"
                 [class.recup]="slot.coffee.Recup"
                  appDragDrop
                  [dragDisabled]="!editMode"
                  [dragData]="getCoffeeDragPayload(slot.coffee)"
                  (dragstart)="onCoffeeDragStart($event, slot.coffee); $event.stopPropagation()"
                  (dragend)="onCoffeeDragEnd()">

             {{slot.coffee.InventoryID}} - {{ slot.coffee.InventoryTypeName }}

            </div>
            }
            @else {
            <span class="slot-text">
              {{ editMode ? 'Drop coffee' : 'Empty' }}
            </span>
            }

          </div>
        </ng-template>
      </div>
      @if(SelectedCuppingSession && !SelectedCuppingSession.editTables) {
      <button mat-button class="btn-bg-green" [disabled]="savingSession || !canCompleteSession" (click)="CompleteSession()">Complete Cupping</button>
      }
    </div>
    }
  </rms-mod>
</div>
}
@else{
<section class="live-workspace">
  <header class="live-header">
    <div><h1>Live cupping</h1><p>Follow the current coffee and compare its scores.</p></div>
    <button mat-button class="btn-bg-blue" (click)="ViewSessionsScreen = false"><mat-icon>arrow_back</mat-icon>Back to sessions</button>
  </header>
  <div class="live-content">
    @if(TodaysSessions.length == 0 && !ActiveSession){
      <div class="live-empty"><mat-icon>coffee</mat-icon><h2>No sessions scheduled for today</h2><p>Today's sessions will appear here when they are set up.</p></div>
    } @else if(!ActiveSession){
      <div class="live-sessions">
        @for(session of TodaysSessions; track session.CuppingSessionKey){
          <fieldset class="rms-fieldset live-session-card">
            <legend>Session #{{session.CuppingSessionKey}}</legend>
            <rms-table [data]="session.CuppingSessionDetails" [columns]="CuppingSessionDetailColumns"></rms-table>
          </fieldset>
        }
      </div>
    } @else {
      <div class="live-coffee-heading">
        <div><p class="live-eyebrow">Reference {{ActiveSession.InventoryID ?? ActiveSession.OfferSampleID}} @if(ActiveSession.PurchaseOrderID > 0){ · PO {{ActiveSession.PurchaseOrderID}} }</p>
        <h2>{{ActiveSession.InventoryTypeName}}</h2><p>{{ActiveSession.SupplierName}}</p></div>
        <span class="live-stage">{{ActiveSession.OfferSampleID ? 'Offer sample' : (ActiveSession.PreShip ? 'Preship sample' : 'Arrival sample')}}</span>
      </div>
      <div class="live-score-layout">
        <section class="live-card">
          <div class="live-total"><div><span>Current SCAA total</span><strong>{{ActiveSession.SCAATotal ?? '—'}}</strong></div>
            @if(ActivePreShip){<div class="live-preship-total"><span>Preship total</span><strong>{{ActivePreShip.SCAATotal ?? '—'}}</strong></div>}
          </div>
          <table class="live-scores"><thead><tr><th scope="col">Attribute</th><th scope="col">Current</th><th scope="col">Preship</th></tr></thead>
            <tbody>@for(attribute of ['Acidity','Body','Sweetness','Aftertaste','Overall']; track attribute){
              <tr><th scope="row">{{attribute}}</th><td>{{ActiveSession[attribute] ?? '—'}}</td><td>{{ActivePreShip?.[attribute] ?? '—'}}</td></tr>
            }</tbody>
          </table>
          @if(!ActivePreShip){<p class="live-muted">No preship scores available for comparison.</p>}
          @if(ActiveSession.CuppingNotes){<div class="live-notes"><h3>Cupping notes</h3><p>{{ActiveSession.CuppingNotes}}</p></div>}
        </section>
        <section class="live-card live-history"><h3>Last 5 cuppings</h3>
          @if(ActiveSession.PreviousCuppings?.length){
            <rms-table [IncludeSearch]="false" [data]="ActiveSession.PreviousCuppings" [IncludePaginator]="false" [columns]="PreviousCuppingsColumns"></rms-table>
          } @else {<p class="live-muted">No previous cuppings available.</p>}
        </section>
      </div>
    }
  </div>
</section>
}
